export default "__VITE_ASSET__98b205b8__"